import React, { useState, useEffect } from "react";
import { Table, Modal, message, Button, Tag, Form, Row, Upload } from "antd";
import {
  DownloadOutlined,
  PlusOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import InspectionApi from "@api/inspectionnew";
import sysApi from "@api/sys";
import SearchForm from "@components/SearchForm";
import HandleButton from "@components/HandleButton";
import { connect } from "react-redux";
import moment from "moment";
import { getStationData, toolMouseTip } from "@utils/common";
import AddModel from "./add";
import download from "@utils/download";
import "../style.scss";
const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 17 },
};
//  0-待处理,1-处理中,2-已关闭, 3-已转工单
const StatusData = ["待处理", "处理中", "已完成"];
const OrderCom = (props) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]); // 表格数据
  const [editVisible, setEditVisible] = useState(false);
  const [editTitle, setEditTitle] = useState("新增保养模板");
  const [rowParams, setRowParams] = useState();
  const [fileList, setFileList] = useState([]);
  const [uploadVisible, setUploadVisible] = useState(false);
  const [detailInfo, setDetailInfo] = useState({});
  const [detailVisible, setDetailVisible] = useState(false);
  // 查询参数
  // 搜索相关参数
  const [searchParams, setSearchParams] = useState({
    pageNum: 1,
    pageSize: 10,
  });
  const [total, setTotal] = useState(0);

  // 搜索
  const [inputList] = useState([
    {
      label: "名称:",
      name: "templateName",
      message: "请输入模板名称",
      span: 8,
      labelCol: 6,
    },
  ]);
  const [selectList] = useState([
    {
      label: "状态:",
      name: "status",
      message: "请选择状态",
      attr: { allowClear: true },
      options: [
        {
          title: "启用",
          value: 1,
        },
        {
          title: "禁用",
          value: 0,
        },
      ],
    },
  ]);

  const [stationData, setStationData] = useState();

  useEffect(() => {
    getStationList();
  }, []);
  // 获取厂站列表
  const getStationList = () => {
    const data = getStationData(
      props.userInfo.stationIds ? props.userInfo.stationIds : '-1',
      props.userInfo.stationAliasName
    );
    setStationData(data);
  };

  useEffect(() => {
    getListByPages();
  }, [searchParams]);

  const getListByPages = () => {
    setLoading(true);
    InspectionApi.upkeepTemplate(searchParams).then((res) => {
      setLoading(false);
      if (res.status == 0 && res.data) {
        setData(res.data.data || []);
        setTotal(res.data.total);
      }
    });
  };

  // 分页
  const handleTableChange = (pagination) => {
    let params = {
      ...searchParams,
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    };
    setSearchParams(params);
  };

  /**
   * 搜索
   * @param params
   */
  const search = (paramsObj) => {
    console.log(paramsObj, "paramsObj");
    let params = {
      ...paramsObj,
      pageNum: 1,
      pageSize: 10,
      stationId: paramsObj.stationId && paramsObj.stationId * 1,
    };
    setSearchParams(params);
  };

  // 禁用
  const disenable = async (id) => {
    // 获取流程id
    const result = await sysApi.getFlowableId({
      dictType: "sw-flowable",
      dictKey: "upkeep_template_status_disable",
    });
    if (result.status !== "0") return;
    const processId = result.data;
    const res = await InspectionApi.upkeepTemplateDisenable({ id, processId });
    if (res.status !== "0") return;
    message.success("禁用成功");
    getListByPages();
  };
  // 启用
  const enable = async (id) => {
    const result = await sysApi.getFlowableId({
      dictType: "sw-flowable",
      dictKey: "upkeep_template_status_enable",
    });
    if (result.status !== "0") return;
    const processId = result.data;
    const res = await InspectionApi.upkeepTemplateEnable({ id, processId });
    if (res.status !== "0") return;
    message.success("启用成功");
    getListByPages();
  };
  // 编辑
  const showEdit = async (id) => {
    const res = await InspectionApi.upkeepTemplateGetInfo(id);
    setEditTitle("编辑模板");
    res.data.upkeepTemplateItemDTOList.map(
      (item) => (item.unit = item.period.substring(item.period.length - 2))
    );
    res.data.upkeepTemplateItemDTOList.map(
      (item) => (item.period = item.period.substring(0, item.period.length - 2))
    );
    setRowParams({ ...res.data,templateType: 1, id });
    setEditVisible(true);
  };

  const showDetail = async (id) => {
    const res = await InspectionApi.upkeepTemplateGetInfo(id);
    setDetailInfo({ ...res.data });
    setDetailVisible(true);
  };

  const btnList = [
    {
      title: "新增",
      type: "primary",
      visible:
        props.userInfo.btnResources.indexOf("upkeep:template:add") !== -1
          ? true
          : false,
      icon: <PlusOutlined />,
      onClick: () => {
        setRowParams({
		  templateType: 1,
          upkeepTemplateItemDTOList: [
            {
              unit: "个周",
              grease: "",
              itemContent: "",
              oilMass: "",
              period: "1",
            },
          ],
        });
        setEditVisible(true);
      },
    },
    {
      title: "批量导入",
      icon: <UploadOutlined />,
      style: { marginLeft: "10px" },
      visible:
        props.userInfo.btnResources.indexOf("upkeep:template:batchImport") !==
        -1
          ? true
          : false,
      type: "primary",
      icon: <PlusOutlined />,
      onClick: () => {
        setUploadVisible(true);
      },
    },
    {
      title: "下载模板",
      style: { marginLeft: "10px" },
      type: "primary",
      visible: true,
      icon: <DownloadOutlined />,
      onClick: () => {
        InspectionApi.downloadUpkeepTemplate().then((res) => {
          download(res, "保养模板.xlsx");
        });
      },
    },
  ];

  const UploadPropsprops = {
    beforeUpload() {
      return false;
    },
    accpet: ".xls",
    action: "#",
    showUploadList: true,
    maxCount: 1,
    onChange(info) {
      const name = info.file.name;
      if (name.indexOf(".xls") < 0 && name.indexOf(".xlsx") < 0) {
        message.warning("所选文件的格式不正确！");
        setFileList([]);
        return false;
      }
      info.file.status = "done";
      setFileList([info.file]);
    },
    fileList,
    onRemove(file) {
      let f = fileList;
      const { uid } = file;
      const idx = fileList.findIndex((item) => item.uid == uid);
      f.splice(idx, 1);
      setFileList([...f]);
    },
  };

  const submit = () => {
    form.validateFields().then((values) => {
      if (!values) {
        return;
      }
      if (!fileList) return message.error("请上传文件");
      const formData = new FormData();
      formData.append("file", fileList[0]);
      InspectionApi.upkeepTemplateBatchImport(formData, {
        "Content-Type":
          "multipart/form-data; boundary=----WebKitFormBoundaryYmNa307cOmXILq7Z",
      }).then((res) => {
        if (res.status === "0") {
          message.success("上传成功");
          form.resetFields();
          setUploadVisible(false);
          getListByPages();
        }
      });
    });
  };

  const columns = [
    {
      title: "名称",
      dataIndex: "templateName",
      align: "center",
      key: "templateName",
      render: (_t) => toolMouseTip(_t, 15),
    },
    {
      title: "模板类型",
      dataIndex: "templateType",
      align: "center",
      key: "templateType",
      render: (obj) => {
        return obj ? "操作人员模板" : "设备人员模板";
      },
    },
    {
      title: "状态",
      dataIndex: "status",
      align: "center",
      key: "status",
      render: (obj) => (
        <Tag color={obj ? "#87d068" : "#FF3819"}> {obj ? "启用" : "禁用"} </Tag>
      ),
    },
    {
      title: "审批状态",
      dataIndex: "approvalStatus",
      align: "center",
      key: "approvalStatus",
      render: (val) => {
        if (val == 1) {
          return <Tag color="#2D99FF">审批中</Tag>;
        } else if (val == 2) {
          return <Tag color="#87d068">通过</Tag>;
        } else if (val == 3) {
          return <Tag color="#FF3819">拒绝</Tag>;
        } else {
          return "-";
        }
      },
    },
    {
      title: "创建时间",
      dataIndex: "createAt",
      align: "center",
      key: "createAt",
      render: (obj) => {
        if (obj) {
          return moment(obj).format("YYYY-MM-DD HH:mm:ss");
        }
      },
    },
    {
      title: "操作",
      key: "operation",
      width: "200px",
      fixed: "right",
      render: (obj, record) => {
        return (
          <>
            {props.userInfo.btnResources.indexOf("upkeep:template:edit") !==
              -1 && (
              <Button
                className="worningBtn"
                size="small"
                type="primary"
                onClick={() => showEdit(record.id)}
              >
                编辑
              </Button>
            )}
            {props.userInfo.btnResources.indexOf("upkeep:template:disable") !==
              -1 &&
              record.status == 1 &&
              record.approvalStatus !== 1 && (
                <Button
                  className="deleteBtn"
                  size="small"
                  type="primary"
                  style={{ marginLeft: 10 }}
                  onClick={() => disenable(record.id)}
                >
                  禁用
                </Button>
              )}
            {props.userInfo.btnResources.indexOf("upkeep:template:enable") !==
              -1 &&
              record.status == 0 &&
              record.approvalStatus !== 1 && (
                <Button
                  className="success"
                  size="small"
                  type="primary"
                  style={{ marginLeft: 10 }}
                  onClick={() => enable(record.id)}
                >
                  启用
                </Button>
              )}
            {props.userInfo.btnResources.indexOf("upkeep:template:info") !==
              -1 && (
              <Button
                size="small"
                type="primary"
                onClick={() => showDetail(record.id)}
                style={{ marginLeft: 10 }}
              >
                详情
              </Button>
            )}
          </>
        );
      },
    },
  ];
  return (
    <div className="baseContent boundary">
      <div className="title">
        <div style={{ marginLeft: "24px" }}>
          <SearchForm
            span={6}
            inputList={inputList}
            selectList={selectList}
            onSearch={search}
          />
        </div>
        <HandleButton
          btnList={btnList}
          btnStyle={{ padding: "0 24px 20px", textAlign: "right" }}
        />
        <Table
          className="Table"
          scroll={{ x: columns.length * 200 }}
          columns={columns}
          dataSource={data}
          rowKey={(record) => record.id}
          pagination={{
            current: searchParams.pageNum,
            pageSize: searchParams.pageSize,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal: (total) => `共${total}条数据`,
            total: total,
          }}
          onChange={handleTableChange}
          loading={loading}
        />
        {uploadVisible && (
          <Modal
            title="批量导入"
            width={620}
            open={uploadVisible}
            footer={[
              <Row key={"btn"} span={24}>
                <Button
                  key={1}
                  onClick={() => {
                    setUploadVisible(false);
                  }}
                  className="abuttons"
                >
                  <i className="iconfont iconfanhui"></i>&nbsp;&nbsp;取消
                </Button>
                <Button
                  key={2}
                  loading={loading}
                  onClick={submit}
                  className="abuttons"
                  type="primary"
                >
                  <i className="iconfont iconbaocun"></i>&nbsp;&nbsp;保存
                </Button>
              </Row>,
            ]}
          >
            <Form
              {...layout}
              layout="horizontal"
              form={form}
              style={{ marginTop: "20px" }}
            >
              <Form.Item
                label="模版文件"
                name="file"
                rules={[{ required: true, message: "请选择文件!" }]}
              >
                <Upload {...UploadPropsprops}>
                  {
                    <div className="upload-clk-area">
                      <Button type="primary">上传文件</Button>
                    </div>
                  }
                </Upload>
              </Form.Item>
            </Form>
          </Modal>
        )}
        {editVisible && (
          <AddModel
            stationData={stationData}
            visible={editVisible}
            title={editTitle}
            formData={rowParams}
            cancel={(bool) => {
              setEditVisible(false);
              bool && getListByPages();
            }}
          />
        )}
        <Modal
          title="保养模板详情"
		  width={620}
          open={detailVisible}
          onOk={() => setDetailVisible(false)}
          onCancel={() => setDetailVisible(false)}
        >
          <div className="instru-detail">
            <div className="defect-detail-td">
              <div className="defect-detail-title">
                {detailInfo.templateName}
              </div>
              <div className="defect-detail-status">
                <Tag color={detailInfo.status ? "#87d068" : "#FF3819"}>
                  {" "}
                  {detailInfo.status ? "启用" : "禁用"}{" "}
                </Tag>
              </div>
            </div>
            <div className="defect-detail-bd">
              <div className="defect-detail-bd-item">
                <div className="defect-detail-item-lable">模板类型：</div>
                <div className="defect-detail-item-desc">
                  {detailInfo.templateType ? "操作人员模板" : "设备人员模板"}
                </div>
              </div>
              <div className="defect-details-list">
                <div className="defect-details-list-item">
                  <div className="defect-details-list-item-td">
                    <div className="defect-detail-item-lable">保养项：</div>
                  </div>
                  {detailInfo.upkeepTemplateItemDTOList &&
                    detailInfo.upkeepTemplateItemDTOList.length > 0 &&
                    detailInfo.upkeepTemplateItemDTOList.map((item) => {
                      return (
                        <div
                          className="defect-details-list-item-bd"
                          key={item.id}
                        >
						 <div className="defect-details-item-content">
						   <div className="defect-details-item-content-label">
						     内容编号
						   </div>
						   <div className="defect-details-item-content-text">
						     {item.contentTag}
						   </div>
						 </div>
                          <div className="defect-details-item-content">
                            <div className="defect-details-item-content-label">
                              保养内容
                            </div>
                            <div className="defect-details-item-content-text">
                              {toolMouseTip(item.itemContent, 5)}
                            </div>
                          </div>
                          <div className="defect-details-item-content">
                            <div className="defect-details-item-content-label">
                              油脂
                            </div>
                            <div className="defect-details-item-content-text">
                              {item.grease ? item.grease : "-"}
                            </div>
                          </div>
                          <div className="defect-details-item-content">
                            <div className="defect-details-item-content-label">
                              油量
                            </div>
                            <div className="defect-details-item-content-text">
                              {item.oilMass ? item.oilMass : "-"}
                            </div>
                          </div>
                          <div className="defect-details-item-content">
                            <div className="defect-details-item-content-label">
                              周期
                            </div>
                            <div className="defect-details-item-content-text">
                              {item.period}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};

export default connect(mapStateToProps)(OrderCom);
